module.exports = "pegasus/assets/blocks/column-14-basic.png";